import React from 'react';
import { Card } from './ui/card';
import { Sparkles } from 'lucide-react';
import { services } from '../mockData';

const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <div className="inline-flex items-center space-x-2 bg-emerald-50 px-4 py-2 rounded-full mb-4">
            <Sparkles className="w-5 h-5 text-emerald-600" />
            <span className="text-sm font-semibold text-emerald-600">Our Services</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Marble & Granite Cutting, Fixing & Polishing Services in Bangalore
          </h2>
          <p className="text-lg text-gray-600">
            The best stone contractors near you — 40 years of precision cutting, flawless fixing and mirror polishing across all Bangalore areas
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <Card 
              key={service.id}
              data-testid={`service-card-${service.slug}`}
              className="group overflow-hidden border-2 border-gray-100 hover:border-emerald-200 hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden h-48">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="text-xl font-bold text-white">{service.title}</h3>
                </div>
              </div>
              <div className="p-6">
                <p className="text-gray-600 leading-relaxed">{service.description}</p>
                <div className="flex flex-wrap gap-2 mt-4">
                  {service.tags.map((tag) => (
                    <span key={tag} className="text-xs font-medium text-emerald-700 bg-emerald-50 border border-emerald-100 px-2.5 py-1 rounded-full">
                      {tag}
                    </span>
                  ))}
                </div>
                <button 
                  onClick={() => {
                    const element = document.getElementById('contact');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="mt-4 text-emerald-600 font-semibold hover:text-emerald-700 transition-colors inline-flex items-center group"
                >
                  Get a Quote
                  <span className="ml-2 group-hover:translate-x-1 transition-transform">→</span>
                </button>
              </div>
            </Card>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">Don't see what you're looking for?</p>
          <button 
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            data-testid="services-custom-cta"
            className="inline-flex items-center px-6 py-3 bg-emerald-600 text-white font-semibold rounded-lg hover:bg-emerald-700 transition-colors shadow-lg hover:shadow-xl"
          >
            Contact Us for Custom Solutions
          </button>
        </div>
      </div>
    </section>
  );
};

export default Services;
